<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0"> {{ $t('ELE0015') }} {{ $t('ELE0056') }} </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="8">
            <v-row align-content="center">
              <v-col cols="3">
                <v-form @submit.prevent="onClickSearch">
                  <TextFieldRef v-if="isInquiry" :label="$t('ELE0213')" prependIcon="mdi-qrcode" :value="qrCode" />
                  <TextFieldInput
                    ref="txtQr"
                    autofocus
                    v-else
                    :label="$t('ELE0213')"
                    prependIcon="mdi-qrcode"
                    isQRField
                    v-model="qrCode"
                    @blur="onClickSearch"
                    maxLength="200"
                  />
                </v-form>
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <!-- <BtnSearch v-if="isEdit" @click="onClickSearch" /> -->
                <BtnReset :disabled="!isInquiry" @click="onResetClick" />
              </v-col>
              <v-col v-if="isInquiry" cols="auto" class="d-flex align-center">
                <Btn :label="isRegistered ? $t('ELE0197') : $t('ELE0196')" @click="onViewClick" :disabled="!canEdit" />
              </v-col>
              <v-col v-if="isInquiry" cols="auto" class="d-flex align-center">
                <v-card-text v-if="isRegistered" class="pa-0 text-h6 font-weight-bold red--text text--darken-2">
                  {{ $t('ELE0205') }} !
                </v-card-text>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row dense v-if="isInquiry">
              <v-col>
                <TextFieldRef :label="$t('ELE0138')" :value="lotInformation.inspDate" />
              </v-col>
              <v-col>
                <TextFieldRef :label="$t('ELE0175')" right :value="lotInformation.inspQty" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="isInquiry">
        <QrPartLotInformationForm
          :qrInformation="qrInformation"
          :partsInformation="partsInformation"
          :lotInformation="lotInformation"
        />
        <!-- <v-card-text class="px-0">
          <Btn :label="$t('ELE0200')" @click="onViewClick" />
        </v-card-text> -->
      </v-card-text>

      <RegisterInspBoxDialog
        v-if="dialog"
        :dialog.sync="dialog"
        :inspQty="lotInformation.inspQty"
        :inspDate="lotInformation.inspDate"
        :maxInspQty="lotInformation.acceptanceQty"
        @register="onRegister"
        @unregister="onUnregister"
      />
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import { FormMode } from '@/enum'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch.vue'
import BtnReset from '@/components/atoms/button/BtnReset.vue'
import Btn from '@/components/atoms/base/button/Btn.vue'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef.vue'
import QrPartLotInformationForm from '@/components/organisms/terminal/form/QrPartLotInformationForm.vue'
import dayjs from 'dayjs'
import RegisterInspBoxDialog from '@/components/organisms/terminal/dialog/RegisterInspBoxDialog.vue'

export default {
  name: 'BoxInformationForm',

  components: {
    TextFieldInput,
    BtnSearch,
    BtnReset,
    Btn,
    TextFieldRef,
    QrPartLotInformationForm,
    RegisterInspBoxDialog,
  },

  mixins: [APIUtils, Message, Loading],

  data() {
    return {
      qrCode: '',
      dialog: false,
      formMode: FormMode.EDIT,
      qrInformation: {
        companyCd: '',
        partCd: '',
        lotNo: '',
        qty: '',
        remarks: '',
      },
      partsInformation: {
        inspFiltering: '',
        inspTimingCd: '',
        partInspTimingName: '',
        inspBasicQty: '',
        inspLevelAqlRate: '',
        xrfLastDatetime: '',
        isXrfExpired: false,
        measIns: '',
      },
      lotInformation: {
        inspStatus: '',
        inspQty: '',
        inspDate: '',
        acceptanceQty: '',
        lotQty: '',
        sampleSize: '',
        acQty: '',
        reQty: '',
      },
    }
  },

  computed: {
    isEdit: {
      get() {
        return this.formMode == FormMode.EDIT
      },
    },
    isInquiry: {
      get() {
        return this.formMode == FormMode.INQUIRY
      },
    },
    canEdit: {
      get() {
        return this.$store.getters.hasEditRole
      },
    },
    isRegistered: {
      get() {
        return this.lotInformation.inspQty && this.lotInformation.inspDate
      },
    },
  },

  methods: {
    onViewClick() {
      this.dialog = true
    },
    onResetClick() {
      this.formMode = FormMode.EDIT
      this.qrCode = ''
      this.qrInformation = ''
      this.partsInformation = ''
      this.lotInformation = ''
      this.$refs?.txtQr?.focus()
    },
    async onClickSearch() {
      if (!this.qrCode) return
      this.startLoading()
      const isQrCode = this.qrCode.split('|Z5')[1]
      try {
        // let inspTimingCd = OqcIqcCd.IQC
        // if (this.$store.getters.canOQCOnly) {
        //   inspTimingCd = OqcIqcCd.OQC
        // }
        let params = {
          qrCode: this.qrCode,
          userCompanyCd: this.$store.getters.companyCd,
          inspTimingCd: this.$store.getters.getIQCorOQC,
        }
        if (!isQrCode) {
          params['refNo'] = this.qrCode
        }
        const data = await API.get('/box/getBoxInfo', params)
        if (data) {
          this.qrInformation = {
            refNo: data.refNo,
            companyCd: data.manufacturerCd,
            partCd: data.partCd,
            partName: data.partName,
            lotNo: data.lotNo,
            qty: data.qty,
            remarks: data.remarks,
          }
          this.partsInformation = {
            inspFiltering: data.inspFilteringName,
            inspTimingCd: data.inspTimingCd,
            partInspTimingName: data.partInspTimingName,
            inspBasicQty: data.inspBasicQty,
            inspLevelAqlRate: data.aqlRateName,
            xrfLastDatetime: data.xrfLastDatetime ? dayjs(data.xrfLastDatetime).format('YYYY-MM-DD HH:mm:ss') : '',
            isXrfExpired: data.isXrfExpired,
            measIns: data.measInstName,
          }
          this.lotInformation = {
            inspStatus: data.inspStatusCd ? this.$t(`InspIndex.InspStatusCd.${data.inspStatusCd}`) : '',
            inspQty: data.inspQty,
            inspDate: data.inspDate,
            acceptanceQty: data.qty,
            lotQty: data.lotQty,
            sampleSize: data.aqlSamplingSize,
            acQty: data.acQty,
            reQty: data.reQty,
          }
          this.formMode = FormMode.INQUIRY
        }
      } catch (error) {
        this.$refs.txtQr.focus()
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0163') })))
      } finally {
        this.stopLoading()
      }
    },
    async onRegister(obj) {
      this.startLoading()
      const isQrCode = this.qrCode.split('|Z5')[1]
      try {
        let body = {
          qrCode: this.qrCode,
          inspTimingCd: this.$store.getters.getIQCorOQC,
          manufacturerCd: this.qrInformation.companyCd,
          partCd: this.qrInformation.partCd,
          lotNo: this.qrInformation.lotNo,
          inspDate: obj.inspDate,
          inspQty: obj.inspQty,
        }
        if (!isQrCode) {
          body['refNo'] = this.qrCode
        }
        const response = await API.post('/box/inspBoxes/register', body)
        if (response) {
          this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0186') }))
          this.onClickSearch()
          this.dialog = false
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0186') })))
      } finally {
        this.stopLoading()
      }
    },
    async onUnregister() {
      this.startLoading()
      const isQrCode = this.qrCode.split('|Z5')[1]
      try {
        const body = {
          qrCode: this.qrCode,
          inspTimingCd: this.$store.getters.getIQCorOQC,
        }
        if (!isQrCode) {
          body['refNo'] = this.qrCode
        }
        const response = await API.post('/box/inspBoxes/delete', body)
        if (response) {
          this.setSuccessMessage(this.$t('MSG0014', { p0: this.$t('ELE0186') }))
          this.onClickSearch()
          this.dialog = false
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0004', { p0: this.$t('ELE0186') })))
      } finally {
        this.stopLoading()
      }
    },
  },
}
</script>
